export default "__VITE_ASSET__ajN7uuvX__"